import { AppType } from '../models/AppType';

export const getAppType = () => {
  const appTypeString = (document.querySelector('meta[name="app-type"]') as HTMLMetaElement | undefined)?.content;
  
  return appTypeString?.toLowerCase() === 'datarequest' ? AppType.DATA_REQUEST : AppType.FORM;
};
